var map = {
	"./ic_charity.svg": "7SWr",
	"./ic_conferences.svg": "5H2n",
	"./ic_festivals.svg": "wyKx",
	"./ic_government.svg": "GO8W",
	"./ic_live_events.svg": "gsDX",
	"./ic_schools.svg": "79Cv"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mVo1";